import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

import { queryKeys } from "#lib/query-keys.ts"
import { FleetListDocument } from "#pages/authenticated/fleet/page.tsx"
import { client } from "#utils/graphql-client.ts"

export const Route = createFileRoute("/_authenticated/$slug/fleet/")({
  loader: async ({ context: { queryClient, userInfo } }) => {
    if (userInfo.state !== "LoggedIn") return

    await queryClient.ensureQueryData({
      queryKey: queryKeys.aircraft.list(userInfo.me.organization.id),
      queryFn: () =>
        client.request(FleetListDocument, {
          input: {
            // TODO get from aircraft
            sources: ["LEON", "MANUAL"],
            organizationId: userInfo.me.organization.id,
          },
        }),
    })
  },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/fleet/page.tsx"),
    "Fleet",
  ),
})
